const HauGiang = {
    //network info
    averageBlockTime: 2,
    chainId: '0x26aa', // 9898
    name: 'Hau Giang',
    shortName: 'hg',
    token: 'HG',
    type: 'Ethereum 1.0',
    timeInterval: 5_000,

    //endpoint
    endpoint: process.env.HAU_GIANG_ENDPOINT,
    chainApiEndpoint: process.env.HAU_GIANG_API_ENDPOINT,
    // infoApiEndpoint: process.env.HAU_GIANG_INFO_ENDPOINT,

    //style
    chartStyle: ['#e06106', '#f9b634'],
    color: {
        from: '#e06106',
        to: '#f9b634',
        fromPosition: '17.65%',
        toPosition: '95.01%'
    },

    //image
    backgroundImage: 'https://res.cloudinary.com/vbchain/image/upload/v1627889597/block_explorer/besuHome_x0z9fe.svg',

    networkIcon: 'https://res.cloudinary.com/dwcf5cmei/image/upload/v1741245560/vbchain/bnfgrtnnd9vymvjf0ihr.png',
    averageBlockTimeIcon:
        'https://res.cloudinary.com/vbchain/image/upload/v1627891947/block_explorer/GeneralInfo/Hyperledger%20Besu/besuBlocktime_luatdu.svg',
    totalTransactionsIcon:
        'https://res.cloudinary.com/vbchain/image/upload/v1627891947/block_explorer/GeneralInfo/Hyperledger%20Besu/besuTransaction_vknqhu.svg',
    totalActiveAddressesIcon:
        'https://res.cloudinary.com/vbchain/image/upload/v1627891947/block_explorer/GeneralInfo/Hyperledger%20Besu/besuAccount_lfrfye.svg',
    latestBlockIcon:
        'https://res.cloudinary.com/vbchain/image/upload/v1627891947/block_explorer/GeneralInfo/Hyperledger%20Besu/besuBlock_x4urtq.svg'
}

module.exports = HauGiang
